import axiosInstance from "./axiosInstance";

export const contentTrackerAPI = {
  getOverview: async (params) => {
    const response = await axiosInstance.get("analytics/content-overview", {
      params,
    });
    return response.data;
  },
  getTrends: async (params) => {
    const response = await axiosInstance.get("analytics/content-trends", {
      params,
    });
    return response.data;
  },
  getRawData: async (params) => {
    const response = await axiosInstance.get("analytics/content-raw-data", {
      params,
    });
    return response.data;
  },
};
export const salesTrackerAPI = {
  getOverview: async (params) => {
    const response = await axiosInstance.get("analytics/sales-overview", {
      params,
    });
    return response.data;
  },
  getTrends: async (params) => {
    const response = await axiosInstance.get("analytics/sales-trends", {
      params,
    });
    return response.data;
  },
  getRawData: async (params) => {
    const response = await axiosInstance.get("analytics/sales-raw-data", {
      params,
    });
    return response.data;
  },
};
export const nmvTrackerAPI = {
  getOverview: async (params) => {
    const response = await axiosInstance.get("analytics/nmv-overview", {
      params,
    });
    return response.data;
  },
  getTrends: async (params) => {
    const response = await axiosInstance.get("analytics/nmv-trends", {
      params,
    });
    return response.data;
  },
  getAllTimePendingGmvOverview: async (params) => {
    const response = await axiosInstance.get(
      "/notification/nmv-pending-status",
    );
    return response.data;
  },
};
